import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">

        <div className="footer-brand">
          <h2>Taxi Asprotaxi</h2>
          <p>Transport privé à Montbéliard et Sainte-Suzanne</p>
        </div>

        <div className="footer-contact">
          <h3>Contact</h3>
          <p>📞 <a href="tel:+33777685938">+33 7 77 68 59 38</a></p>
          <p>📧 <a href="mailto:taxi.asprotaxi@gmail.com">taxi.asprotaxi@gmail.com</a></p>
        </div>

        <div className="footer-links">
          <h3>Navigation</h3>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/propos">À propos</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/tarifs">Tarifs</Link></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Le Transport de la Douce – Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;

